export const langChangePass = {
    "arm": {
        tr_passDoesNotMatch: "Գաղտնաբառը չի համընկնում",
        tr_passLengthValid: "Գաղտնաբառր պետք է ունենա մինիմում 8 սիմվոլ",
        tr_confirm: "Հաստատել",
        tr_oldPass: "Հին Գաղտնաբառ ",
        tr_newPass: "Նոր Գաղտնաբառ",
        tr_confirmPass: "Հաստատել Գաղտնաբառը",
        tr_passLengthValidate: "Գաղտնաբառր պետք է ունենա մինիմում 8 սիմվոլ",
    },
    "eng": {
        tr_passDoesNotMatch: "The password does not match",
        tr_passLengthValid: "The password should have at least 8 characters",
        tr_confirm: "Confirm",
        tr_oldPass: "Old passowrd",
        tr_newPass: "New passowrd",
        tr_confirmPass: "Confirm password",
        tr_passLengthValidate: "Password must have at least 8 characters",
    },
    "fr": {
        tr_passDoesNotMatch: "Mot de passe invalide",
        tr_passLengthValid: "Le mot de passe doit contenir au minimum 8 caractères",
        tr_confirm: "Approuver",
        tr_oldPass: "Ancien mot de passe",
        tr_newPass: "Nouveau mot de passe",
        tr_confirmPass: "Confirmez le mot de passe",
        tr_passLengthValidate: "Le mot de passe doit comporter au moins 8 caractères",
    },
    "arb": {
        tr_passDoesNotMatch: "كلمة السرّ غير متطابقة",
        tr_passLengthValid: "كلمة السرّ يجب أن يكون مؤلّفاً من 8 رموز على الأقلّ",
        tr_confirm: "تأكيد",
        tr_oldPass: "كلمة المرور القديمة",
        tr_newPass: "كلمة المرور الجديدة",
        tr_confirmPass: "تأكيد كلمة المرور",
        tr_passLengthValidate: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
    },
    "rus": {
        tr_passDoesNotMatch: "Пароли не совпадают",
        tr_passLengthValid: "Пароль должен содержать не менее 8 символов",
        tr_confirm: "Подтвердить",
        tr_oldPass: "Старый пароль",
        tr_newPass: "Новый пароль",
        tr_confirmPass: "Подтвердите пароль",
        tr_passLengthValidate: "Пароль должен содержать не менее 8 символов",
    }
}